export enum ProfileType {
  CUSTOMER = "customer",
  DRIVER = "driver",
  CIF_DRIVER = "cif_driver",
  CARRIER = "carrier",
}

export const PROFILE_OPTIONS = [
  { value: ProfileType.CUSTOMER, label: "Cliente" },
  { value: ProfileType.DRIVER, label: "Motorista" },
  { value: ProfileType.CARRIER, label: "Transportadora" },
  { value: ProfileType.CIF_DRIVER, label: "Motorista CIF" },
];
